/**
 * @generated SignedSource<<03a5599befa2bde792e51bc20f932568>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer" | "ItemHeartWrapper_viewer">;
  readonly " $fragmentType": "CarouselItemTile_viewer";
};
export type CarouselItemTile_viewer$key = {
  readonly " $data"?: CarouselItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "fetchFavorites"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1b689ee6dd27e0e19f75fcb17f29f68a";

export default node;
